import { WithPartialInject } from '../utils/withInject';
import mixins from 'vue-typed-mixins';
const TicketInjector = ticketName => mixins(WithPartialInject(ticketName)).extend({
  computed: {
    ticket() {
      const provider = this[ticketName];
      if (!provider) return null;
      // @ts-expect-error _uid is not given in interface, but it does exist
      const uid = this._uid;
      const i = provider.tickets[uid];
      return i !== -1 ? i : null;
    }
  },
  created() {
    var _this$ticketName;
    (_this$ticketName = this[ticketName]) === null || _this$ticketName === void 0 ? void 0 : _this$ticketName.registerTicket(this);
  },
  beforeDestroy() {
    var _this$ticketName2;
    (_this$ticketName2 = this[ticketName]) === null || _this$ticketName2 === void 0 ? void 0 : _this$ticketName2.unregisterTicket(this);
  }
});
export default TicketInjector;